import { REDUCE_STOREFRONT_CONFIGURATION, REDUCE_USER_INTERFACE } from '../../constants/actions/storefront';

const initialState = {
    storefront: null,
    userInterface: {},
};

function storefrontReducer(state = initialState, action) {
    switch (action.type) {
        case REDUCE_STOREFRONT_CONFIGURATION:
            return { ...state, storefront: action.payload };
        case REDUCE_USER_INTERFACE:
            return { ...state, userInterface: action.payload };
        default:
            return state;
    }
}

export default storefrontReducer;
